import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Tab,
  Stack,
  //IconButton
} from "@mui/material";
//import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { AppContext } from "../context";
import { pathJoinUrl } from "@smfa/utils/src";
import { useAdminReducer } from "../hooks/useAdminReducer";
import {
  getMembershipCategoryBanner,
  updateMembershipCategory,
  getMembershipCategory,
  // getCategoryMembersData,
  // membershipCategoryMember,
  deleteMembershipCategory,
  upsertMembershipCategoryBanner,
} from "../actions/membership.actions";
import DeleteModal from "../ui-components/DeleteModal";
import FileUploadArea from "../components/common/FileUploadArea";
import LimitedTextField from "../components/common/LimitedTextField";
import FormActionBar from "../components/common/FormActionBar";
// Import reusable components
// import SearchControls from "../components/common/SearchControls";
// import DataTable from "../components/common/DataTable";
// import TablePagination from "../components/common/TablePagination";

const Membershipcategories = () => {
  const { storage } = useContext(AppContext);
  const [value, setValue] = useState("1");
  const [deleteItem, setDeleteItem] = useState(null);

  // Direct state for banner images like in original code
  const [deskimage, setDeskImage] = useState("");
  const [mobimage, setMobImage] = useState("");

  // Direct state for banner data like in original
  const [addAboutBanner, setAboutBanner] = useState({
    membership_categories_banner_section_id: 0,
    banner_image: "",
    banner_image_name: "",
    banner_image_error: false,
    banner_image_mob: "",
    banner_image_mob_name: "",
    banner_image_mob_error: false,
    banner_title: "",
    banner_title_maxlenth: 30,
    banner_title_error: false,
  });

  // Member categories data state
  // const [addMemeber, setMemeber] = useState({
  //   membership_categories_members_id: 0,
  //   section_title: "",
  //   section_title_error: false,
  //   section_title_maxlenth: 40,
  //   section_description: "",
  //   section_description_error: false,
  //   section_description_maxlenth: 400,
  // });

  // Use the admin reducer for introduction section and table data management
  const {
    state,
    setLoading,
    isLoading,
    handleFieldChange,
    handleFormError,
    setFormData,
    setMessage,
  } = useAdminReducer({
    formData: {
      membership_categories_section_id: 0,
      section_title: "",
      section_title_error: false,
      section_title_maxlenth: 50,
      section_description: "",
      section_description_error: false,
      section_description_maxlenth: 380,
    },
    memberData: {
      membership_categories_members_id: 0,
      section_title: "",
      section_title_error: false,
      section_title_maxlenth: 40,
      section_description: "",
      section_description_error: false,
      section_description_maxlenth: 400,
    },
    tableData: {
      data: [],
      loading: true,
      pagination: {
        pageNo: 1,
        perPage: 50,
        totalCount: 0,
        totalPage: 1,
      },
      search: {
        text: "",
        type: "section_title",
      },
      sort: {
        field: null,
        direction: null,
      },
    },
  });

  // eslint-disable-next-line no-unused-vars
  const { formData, tableData } = state;
  const { successMsg, errorMsg } = state;

  // Handle tab changes - FIXED
  const handleChange = (event, newValue) => {
    setMessage("", "");
    setLoading(false);
    setValue(newValue);

    // if (newValue === "3") {
    //   resetMemberForm();
    // }

    // // Load member list when switching to manage tab
    // if (newValue === "4") {
    //   setFirstLoading(true);
    //   fetchTableData();
    // }
  };

  // const handleChangeedit = (event, newValue) => {
  //   setMessage("", "");
  //   setLoading(false);
  //   setValue(newValue);
  // };

  // Reset member form
  //const resetMemberForm = () => {
  // setMemeber({
  //   membership_categories_members_id: 0,
  //   section_title: "",
  //   section_title_error: false,
  //   section_title_maxlenth: 40,
  //   section_description: "",
  //   section_description_error: false,
  //   section_description_maxlenth: 400,
  // });

  //   setMessage("", "");
  //   setLoading(false);
  // };

  // Handle banner image changes like original
  const onImageChange = (event) => {
    setMessage("", "");

    var custInfo = { ...addAboutBanner };
    if (event.target.files && event.target.files[0]) {
      setDeskImage(URL.createObjectURL(event.target.files[0]));
      custInfo.banner_image = event.target.files[0];
      custInfo.banner_image_name = event.target.files[0].name;
      custInfo.banner_image_error = false;
      setAboutBanner(custInfo);
    }
  };

  const onMobImageChange = (event) => {
    setMessage("", "");

    var custInfo = { ...addAboutBanner };
    if (event.target.files && event.target.files[0]) {
      setMobImage(URL.createObjectURL(event.target.files[0]));
      custInfo.banner_image_mob = event.target.files[0];
      custInfo.banner_image_mob_name = event.target.files[0].name;
      custInfo.banner_image_mob_error = false;
      setAboutBanner(custInfo);
    }
  };

  const clearUpload = (field, clearPreview) => {
    setAboutBanner((prev) => ({
      ...prev,
      [field]: "",
      [`${field}_name`]: "",
    }));
    clearPreview("");
  };

  // Handle banner title field change
  const addAboutBannerInfo = (event) => {
    setMessage("", "");

    var custInfo = { ...addAboutBanner };
    if (event.target.name === "banner_title") {
      if (event.target.value.length <= addAboutBanner.banner_title_maxlenth) {
        custInfo.banner_title = event.target.value;
        custInfo.banner_title_error = false;
      }
    }

    setAboutBanner(custInfo);
  };

  // Submit banner form
  const submitLocation = () => {
    setLoading(true);
    setMessage("", "");
    var custInfo = { ...addAboutBanner };

    if (addAboutBanner.banner_title === "") {
      custInfo.banner_title_error = true;
      setAboutBanner(custInfo);
      setLoading(false);
      return false;
    }

    const formData = new FormData();
    formData.append(
      "membership_categories_banner_section_id",
      addAboutBanner.membership_categories_banner_section_id,
    );
    formData.append("banner_image_mob", addAboutBanner.banner_image_mob);
    formData.append("banner_image", addAboutBanner.banner_image);
    formData.append("banner_title", addAboutBanner.banner_title);

    upsertMembershipCategoryBanner(formData)
      .then((res1) => {
        if (res1.data.status === true) {
          setMessage("Banner Updated Successfully!", "");

          // Update local state with the response data
          var locInfo = { ...addAboutBanner };

          if (res1.data.data) {
            locInfo.banner_title =
              res1.data.data.banner_title || locInfo.banner_title;

            if (res1.data.data.banner_image) {
              locInfo.banner_image_name = res1.data.data.banner_image;
            }

            if (res1.data.data.banner_image_mob) {
              locInfo.banner_image_mob_name = res1.data.data.banner_image_mob;
            }

            setAboutBanner(locInfo);
          }

          setTimeout(() => setMessage("", ""), 3000);
        } else {
          setMessage(
            "",
            res1.data.message || "Something went wrong, please try again!",
          );
        }
      })
      .catch((error) => {
        log.error("Banner update error:", error);
        setMessage("", "Something went wrong, please try again!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Submit introduction form - ADDED
  const submitIntroduction = () => {
    setLoading(true);
    setMessage("", "");

    // Validation
    let hasError = false;

    if (!formData.section_title) {
      handleFormError("section_title", true, "formData");
      hasError = true;
    }

    if (!formData.section_description) {
      handleFormError("section_description", true, "formData");
      hasError = true;
    }

    if (hasError) {
      setLoading(false);
      return;
    }

    const formDataObj = new FormData();
    formDataObj.append(
      "membership_categories_section_id",
      formData.membership_categories_section_id,
    );
    formDataObj.append("section_title", formData.section_title);
    formDataObj.append("section_description", formData.section_description);

    updateMembershipCategory(formDataObj)
      .then((res) => {
        if (res.data.status === true) {
          setMessage("Introduction Updated Successfully!", "");
          setTimeout(() => setMessage("", ""), 3000);
        } else {
          setMessage(
            "",
            res.data.message || "Something went wrong, please try again!",
          );
        }
      })
      .catch((error) => {
        log.error("Introduction update error:", error);
        setMessage("", "Something went wrong, please try again!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Member Category functionality
  // const addMemeberInfo = (event) => {
  //   setMessage("", "");

  //   var custInfo = { ...addMemeber };
  //   if (event.target.name === "section_title") {
  //     if (event.target.value.length <= addMemeber.section_title_maxlenth) {
  //       custInfo.section_title = event.target.value;
  //       custInfo.section_title_error = false;
  //     }
  //   }
  //   if (event.target.name === "section_description") {
  //     if (
  //       event.target.value.length <= addMemeber.section_description_maxlenth
  //     ) {
  //       custInfo.section_description = event.target.value;
  //       custInfo.section_description_error = false;
  //     }
  //   }

  //   setMemeber(custInfo);
  // };

  // const submitMember = () => {
  //   setLoading(true);
  //   setMessage("", "");

  //   // Validation
  //   let hasError = false;
  //   const updatedState = { ...addMemeber };

  //   if (!addMemeber.section_title) {
  //     updatedState.section_title_error = true;
  //     hasError = true;
  //   }

  //   if (!addMemeber.section_description) {
  //     updatedState.section_description_error = true;
  //     hasError = true;
  //   }

  //   if (hasError) {
  //     setMemeber(updatedState);
  //     setLoading(false);
  //     return;
  //   }

  //   const formData = new FormData();
  //   formData.append(
  //     "membership_categories_members_id",
  //     addMemeber.membership_categories_members_id,
  //   );
  //   formData.append("section_title", addMemeber.section_title);
  //   formData.append("section_description", addMemeber.section_description);

  //   membershipCategoryMember(formData)
  //     .then((res) => {
  //       if (res.data.status === true) {
  //         const action =
  //           addMemeber.membership_categories_members_id === 0
  //             ? "Added"
  //             : "Updated";
  //         setMessage(`Membership Category ${action} Successfully!`, "");

  //         // Reset form
  //         resetMemberForm();

  //         // Refresh table data
  //         fetchTableData();

  //         // Switch to manage tab after brief delay
  //         setTimeout(() => {
  //           setMessage("", "");
  //           const startEvent = new Event("start");
  //           handleChange(startEvent, "4");
  //         }, 1000);
  //       } else {
  //         setMessage(
  //           "",
  //           res.data.message || "Something went wrong, please try again!",
  //         );
  //       }
  //     })
  //     .catch(() => {
  //       setMessage("", "Something went wrong, please try again!");
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // };

  // const editLocation = (e, val) => {
  //   var locInfo = { ...addMemeber };
  //   locInfo.membership_categories_members_id =
  //     val.membership_categories_members_id;
  //   locInfo.section_title = val.section_title;
  //   locInfo.section_description = val.section_description;

  //   log.debug("Setting member data for editing:", locInfo);
  //   setMemeber(locInfo);

  //   setMessage("", "");
  //   const startEvent = new Event("start");
  //   handleChangeedit(startEvent, "3");
  // };

  // Table variables and states
  //const [memberList, setMemberList] = useState([]);
  //const [firstLoading, setFirstLoading] = useState(true);
  // const [pageNo, setPageNo] = useState(1);
  // const [perPage, setPerPage] = useState(50);
  //const [totalCount, setTotalCount] = useState(0);
  //const [totalPage, setTotalPage] = useState(1);
  // const [searchText, setSearchText] = useState("");
  // const [searchType, setSearchType] = useState("section_title");
  //const [pageLoader, setPageLoader] = useState(false);

  // Table data fetching function
  const fetchTableData = (params = {}) => {
    //setFirstLoading(true);
    // const requestParams = {
    //   pageNo: params.pageNo || pageNo,
    //   perPage: params.perPage || perPage,
    //   searchText:
    //     params.searchText !== undefined ? params.searchText : searchText,
    //   searchType: params.searchType || searchType,
    // };
    // sort parameters if available
    // if (params.sort) {
    //   requestParams.sort = params.sort;
    // }
    // if (params.sortField) {
    //   requestParams.sortvalue = params.sortField;
    // }
    // getCategoryMembersData(requestParams)
    //   .then((res) => {
    //     if (res.data && res.data.status === true) {
    //       setMemberList(res.data.data || []);
    //       setTotalCount(res.data.pagination.totalCount);
    //       setTotalPage(res.data.pagination.totalPage);
    //       if (params.pageNo) setPageNo(params.pageNo);
    //       if (params.perPage) setPerPage(params.perPage);
    //       if (params.searchText !== undefined) setSearchText(params.searchText);
    //       if (params.searchType) setSearchType(params.searchType);
    //     } else {
    //       setMemberList([]);
    //     }
    //   })
    //   .catch((error) => {
    //     log.error("Failed to load member data:", error);
    //     setMemberList([]);
    //   })
    //   .finally(() => {
    //     setFirstLoading(false);
    //     setPageLoader(false);
    //   });
  };

  // Delete handling
  const handleDeleteSuccess = () => {
    setDeleteItem(null);
    fetchTableData();
  };

  // Table action handlers
  // const handleSort = (field, direction) => {
  //   fetchTableData({ pageNo: 1, sort: direction, sortField: field });
  // };

  // const handleSearch = () => fetchTableData({ pageNo: 1 });

  // const handleSearchTextChange = (text) => setSearchText(text);

  // const handleSearchTypeChange = (type) => setSearchType(type);

  // const clearFilters = () => {
  //   setSearchText("");
  //   setSearchType("section_title");
  //   fetchTableData({
  //     pageNo: 1,
  //     searchText: "",
  //     searchType: "membership_categories_members_id",
  //   });
  // };

  // const handlePageChange = (page) => {
  //   setPageLoader(true);
  //   fetchTableData({ pageNo: page });
  // };

  // const handlePerPageChange = (newPerPage) => {
  //   fetchTableData({ pageNo: 1, perPage: newPerPage });
  // };

  // Load initial data
  useEffect(() => {
    // Get banner data
    getMembershipCategoryBanner()
      .then((res) => {
        if (res.data && res.data.status === true) {
          var locInfo = { ...addAboutBanner };

          // Set banner data directly
          locInfo.membership_categories_banner_section_id =
            res.data.data.membership_categories_banner_section_id || 0;
          locInfo.banner_title = res.data.data.banner_title || "";
          locInfo.banner_image_name = res.data.data.banner_image || "";
          locInfo.banner_image_mob_name = res.data.data.banner_image_mob || "";

          setAboutBanner(locInfo);

          // Set preview images
          if (res.data.data.banner_image) {
            setDeskImage(
              pathJoinUrl(storage[0].imageEndUrl, res.data.data.banner_image),
            );
          }

          if (res.data.data.banner_image_mob) {
            setMobImage(
              pathJoinUrl(
                storage[0].imageEndUrl,
                res.data.data.banner_image_mob,
              ),
            );
          }
        }
      })
      .catch((error) => {
        log.error("Failed to load banner data:", error);
      });

    // Get introduction data
    getMembershipCategory()
      .then((res) => {
        if (res.data && res.data.status === true) {
          setFormData({
            membership_categories_section_id:
              res.data.data.membership_categories_section_id || 0,
            section_title: res.data.data.section_title || "",
            section_description: res.data.data.section_description || "",
          });
        }
      })
      .catch((error) => {
        log.error("Failed to load introduction data:", error);
      });

    // Load table data if on manage tab
    // if (value === "4") {
    //   fetchTableData();
    // }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Define table columns for DataTable
  // const tableColumns = [
  //   {
  //     field: "index",
  //     label: "Sl No",
  //     width: "10%",
  //     render: (row, index) => (pageNo - 1) * perPage + index + 1,
  //   },
  //   {
  //     field: "section_title",
  //     label: "Title",
  //     width: "25%",
  //     sortable: true,
  //   },
  //   {
  //     field: "section_description",
  //     label: "Short Description",
  //     width: "50%",
  //   },
  //   {
  //     field: "actions",
  //     label: "Actions",
  //     width: "15%",
  //     render: (row) => (
  //       <Stack direction="row" spacing={1}>
  //         <IconButton
  //           size="small"
  //           color="primary"
  //           onClick={() => editLocation(null, row)}
  //           aria-label="edit"
  //         >
  //           <EditIcon fontSize="small" />
  //         </IconButton>
  //         <IconButton
  //           size="small"
  //           color="error"
  //           onClick={() => setDeleteItem(row)}
  //           aria-label="delete"
  //         >
  //           <DeleteIcon fontSize="small" />
  //         </IconButton>
  //       </Stack>
  //     ),
  //   },
  // ];

  // Search options for the search control
  // const searchOptions = [
  //   { value: "section_title", label: "Title" },
  //   { value: "section_description", label: "Description" },
  // ];

  return (
    <Box
      className="body-inner-sec"
      sx={{ marginLeft: "260px !important", p: 3 }}
    >
      This section is for updating the "Membership Categories" banner and intro
      text. Updating the actual membership tiers requires modification in Stripe
      and in a centralized data store in the code (
      <code>@smfa/utils/src/common/products.json</code>)
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange} aria-label="membership tabs">
            <Tab label="Banner" value="1" />
            <Tab label="Introduction" value="2" />
            {/* Add/Manage Categories deprecated for consolidated products JSON */}
            {/* <Tab
              label={`${addMemeber.membership_categories_members_id !== 0 ? "Update" : "Add"} Categories`}
              value="3"
            />
            <Tab label="Manage Categories" value="4" /> */}
          </TabList>
        </Box>

        {/* Banner Tab */}
        <TabPanel value="1">
          <Stack spacing={3}>
            <Box sx={{ maxWidth: 400 }}>
              <LimitedTextField
                id="banner_title"
                name="banner_title"
                label="Title"
                value={addAboutBanner.banner_title}
                onChange={addAboutBannerInfo}
                maxLength={addAboutBanner.banner_title_maxlenth}
                error={addAboutBanner.banner_title_error}
                errorText="Please enter Title!"
              />
            </Box>

            <Stack direction={{ xs: "column", md: "row" }} spacing={3}>
              <Box sx={{ width: "100%" }}>
                <FileUploadArea
                  title="Add Banner Image For Desktop"
                  description={
                    <>
                      Best image Resolution: 1920px X 836px
                      <br />
                      Supported files types: JPG, JPEG & PNG
                    </>
                  }
                  previewUrl={deskimage}
                  fileName={addAboutBanner.banner_image_name}
                  onChange={onImageChange}
                  deleteRequest={{
                    resource: "membership-categories-banner",
                    id: addAboutBanner.membership_categories_banner_section_id,
                    field: "banner_image",
                  }}
                  onRemove={() => clearUpload("banner_image", setDeskImage)}
                  accept=".png,.jpg,.jpeg"
                />
              </Box>

              <Box sx={{ width: "100%" }}>
                <FileUploadArea
                  title="Add Banner Image For Mobile"
                  description={
                    <>
                      Best image Resolution: 400px X 350px
                      <br />
                      Supported files types: JPG, JPEG & PNG
                    </>
                  }
                  previewUrl={mobimage}
                  fileName={addAboutBanner.banner_image_mob_name}
                  onChange={onMobImageChange}
                  deleteRequest={{
                    resource: "membership-categories-banner",
                    id: addAboutBanner.membership_categories_banner_section_id,
                    field: "banner_image_mob",
                  }}
                  onRemove={() =>
                    clearUpload("banner_image_mob", setMobImage)
                  }
                  accept=".png,.jpg,.jpeg"
                />
              </Box>
            </Stack>

            <FormActionBar
              onSubmit={submitLocation}
              isSubmitting={isLoading}
              isEdit={
                addAboutBanner.membership_categories_banner_section_id !== 0
              }
              successMessage={successMsg}
              errorMessage={errorMsg}
              submitLabel="Update"
            />
          </Stack>
        </TabPanel>

        {/* Introduction Tab */}
        <TabPanel value="2">
          <Stack spacing={3}>
            {/* <Box sx={{ maxWidth: 400 }}>
              <LimitedTextField
                id="section_title"
                name="section_title"
                label="Title"
                value={formData.section_title}
                onChange={(e) => handleFieldChange(e, "formData")}
                maxLength={formData.section_title_maxlenth}
                error={formData.section_title_error}
                errorText="Please enter Title!"
              />
            </Box> */}

            <Box>
              <LimitedTextField
                id="section_description"
                name="section_description"
                label="Short Description"
                value={formData.section_description}
                onChange={(e) => handleFieldChange(e, "formData")}
                maxLength={formData.section_description_maxlenth}
                error={formData.section_description_error}
                errorText="Please enter Short Description!"
                multiline
                rows={3}
              />
            </Box>

            <FormActionBar
              onSubmit={submitIntroduction}
              isSubmitting={isLoading}
              isEdit={formData.membership_categories_section_id !== 0}
              successMessage={successMsg}
              errorMessage={errorMsg}
              submitLabel="Update"
            />
          </Stack>
        </TabPanel>

        {/* Add/Edit Categories Tab */}
        {/* <TabPanel value="3">
          <Stack spacing={3}>
            <Box sx={{ maxWidth: 400 }}>
              <LimitedTextField
                id="section_title"
                name="section_title"
                label="Title"
                value={addMemeber.section_title}
                onChange={addMemeberInfo}
                maxLength={addMemeber.section_title_maxlenth}
                error={addMemeber.section_title_error}
                errorText="Please enter Title!"
              />
            </Box>

            <Box>
              <LimitedTextField
                id="section_description"
                name="section_description"
                label="Short Description"
                value={addMemeber.section_description}
                onChange={addMemeberInfo}
                maxLength={addMemeber.section_description_maxlenth}
                error={addMemeber.section_description_error}
                errorText="Please enter Short Description!"
                multiline
                rows={3}
              />
            </Box>

            <FormActionBar
              onSubmit={submitMember}
              onReset={resetMemberForm}
              isSubmitting={isLoading}
              isEdit={addMemeber.membership_categories_members_id !== 0}
              successMessage={successMsg}
              errorMessage={errorMsg}
              submitLabel={
                addMemeber.membership_categories_members_id !== 0
                  ? "Update"
                  : "Save"
              }
              resetLabel="Reset"
            />
          </Stack>
        </TabPanel> */}

        {/* Manage categories Tab*/}
        {/* <TabPanel value="4">
          <SearchControls
            searchText={searchText}
            searchType={searchType}
            searchOptions={searchOptions}
            onSearchChange={handleSearchTextChange}
            onTypeChange={handleSearchTypeChange}
            onSubmit={handleSearch}
            onClear={clearFilters}
            perPage={perPage}
            totalCount={totalCount}
            onPerPageChange={handlePerPageChange}
          />

          <DataTable
            columns={tableColumns}
            data={memberList}
            loading={firstLoading}
            sortConfig={{ field: null, direction: null }}
            onSort={handleSort}
            keyField="membership_categories_members_id"
            noDataMessage="No Membership Categories Found"
          />

          {totalPage > 1 && (
            <TablePagination
              page={pageNo}
              totalPages={totalPage}
              loading={pageLoader}
              onChange={handlePageChange}
              entriesPerPage={perPage}
              onEntriesChange={handlePerPageChange}
            />
          )}
        </TabPanel> */}
      </TabContext>
      <DeleteModal
        open={deleteItem !== null}
        title={"Delete Membership Category"}
        message={"Are you sure you want to delete this Membership Category?"}
        handleClose={() => setDeleteItem(null)}
        handleSuccess={handleDeleteSuccess}
        deleteAction={deleteMembershipCategory}
        data={
          deleteItem
            ? {
                membership_categories_members_id:
                  deleteItem.membership_categories_members_id,
              }
            : null
        }
      />
    </Box>
  );
};

export default Membershipcategories;
